/* Livre de naissance · couche de mouvement v4 (GSAP 3.12.5 + ScrollTrigger, Lenis 1.1.13, Vara 1.4.1).
   N'agit que si les bibliothèques sont chargées et que la visiteuse n'a pas demandé de mouvement réduit.
   Tout ce qui est ici est un plus : sans ce fichier, ln.js montre déjà un site complet (livre ouvert, lettre écrite).
   Règles : transform et opacity seulement (60 i/s), une seule écriture par phrase, aucun son sans geste. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var g = window.gsap, ST = window.ScrollTrigger;
  if (reduit || !g || !ST) return;
  g.registerPlugin(ST);
  var corps = document.body;
  var telephone = function () { return window.innerWidth < 1000; };
  var LNA = window.LNA = window.LNA || {};

  /* Défilement : natif. Lenis retiré le 14/10/2026 : il bloquait complètement le défilement (conflit avec scroll-behavior et ScrollTrigger). */

  /* ---------- l'écriture au stylo (Vara), avec les accents français ---------- */
  var POLICES = { satisfy: corps.dataset.varaSatisfy, parisienne: corps.dataset.varaParisienne };
  var FILE_PLUME = [], fileEnCours = false, dernierDefil = 0;
  /* le moteur d'écriture ne se prépare jamais pendant qu'on fait défiler (sinon une tâche de 70 ms fait accrocher le défilement) */
  window.addEventListener('scroll', function () { dernierDefil = Date.now(); }, { passive: true });
  function lancerFile() {
    if (fileEnCours) return; fileEnCours = true;
    var repos = window.requestIdleCallback || function (f) { return setTimeout(function () { f({ timeRemaining: function () { return 0; } }); }, 120); };
    (function suivant() {
      var tache = FILE_PLUME.shift();
      if (!tache) { fileEnCours = false; return; }
      repos(function lancer() {
        if (Date.now() - dernierDefil < 800) { setTimeout(function () { repos(lancer, { timeout: 1500 }); }, 300); return; }
        try { tache(); } finally { setTimeout(suivant, 60); }
      }, { timeout: 1500 });
    })();
  }
  function ecrire(hote, texte, o) {
    /* hote : élément qui garde son texte (lisible sans animation, et par les lecteurs d'écran) ; la plume dessine par-dessus */
    o = o || {};
    if (!window.Vara || !texte) return null;
    var v = null, pret = false, enAttente = false;
    var boite = document.createElement('span');
    boite.className = 'plume'; boite.setAttribute('aria-hidden', 'true');
    var id = 'pl' + Math.random().toString(36).slice(2, 8); boite.id = id;
    hote.classList.add('a-plume'); hote.appendChild(boite);
    /* filet de sécurité : si la plume n'est pas prête en 4 s, le texte normal revient (jamais de phrase manquante) */
    setTimeout(function () { if (!pret) { hote.classList.remove('a-plume'); if (boite.parentNode) boite.parentNode.removeChild(boite); } }, 4000);
    var place = Math.max(120, hote.getBoundingClientRect().width || 300);
    var taille = Math.min(o.taille || 30, place / (texte.length * (o.police === 'parisienne' ? 0.5 : 0.5)));
    /* le moteur d'écriture se prépare au repos, une phrase à la fois (sinon le téléphone se fige au chargement) */
    FILE_PLUME.push(function () {
      v = new window.Vara('#' + id, POLICES[o.police || 'satisfy'], [{
        text: texte, fontSize: taille, strokeWidth: o.trait || 1.5, color: o.couleur || '#a23d22',
        duration: o.duree || Math.min(3200, 380 + texte.length * 75), id: 0, autoAnimation: false, textAlign: 'left', width: 4000 /* jamais de retour à la ligne : le tracé se réduit à la place disponible */
      }], { autoAnimation: false });
      v.ready(function () {
        pret = true;
        var svg = $('svg', boite); if (svg) {
          /* le tracé prend la largeur de son texte, et se réduit si la place manque (jamais de débordement) */
          var bb = svg.getBBox(); var w = Math.ceil(bb.x + bb.width + 6), h = Math.ceil(bb.y + bb.height + 6);
          svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h); svg.removeAttribute('width'); svg.removeAttribute('height');
          svg.style.width = w + 'px'; svg.style.maxWidth = '100%'; svg.style.height = 'auto';
        }
        hote.classList.add('a-plume--pret');
        if (enAttente) v.draw(0);
      });
    });
    lancerFile();
    return { dessiner: function () { if (pret && v) v.draw(0); else enAttente = true; } };
  }
  LNA.ecrire = ecrire;
  /* les phrases qui s'écrivent quand elles entrent à l'écran (ligne d'ouverture, titres de moments) */
  $$('[data-vara]').forEach(function (el) {
    if (el.closest('[data-ouverture]')) return; /* l'ouverture a son propre scénario */
    var pl = ecrire(el, el.dataset.vara, { taille: Number(el.dataset.varaTaille) || 30, couleur: el.dataset.varaCouleur });
    if (pl) ST.create({ trigger: el, start: 'top 82%', once: true, onEnter: pl.dessiner });
  });
  /* les annotations des marges : la flèche se trace, puis les mots s'écrivent */
  $$('[data-annot]').forEach(function (an) {
    an.classList.remove('is-trace');
    var mot = $('span[class^="m-"]', an), fl = $$('path', an);
    var c = getComputedStyle(an).color;
    var pl = mot ? ecrire(mot, mot.textContent.trim(), { taille: Number(an.dataset.taille) || 24, couleur: c, trait: 1.4 }) : null;
    g.set(fl, { strokeDashoffset: 1 });
    ST.create({ trigger: an, start: 'top 85%', once: true, onEnter: function () {
      an.classList.add('is-trace');
      g.to(fl, { strokeDashoffset: 0, duration: .8, ease: 'power2.inOut', stagger: .25 });
      if (pl) setTimeout(pl.dessiner, 250);
    } });
  });

  /* ---------- le scénario d'ouverture ---------- */
  var ouv = $('[data-ouverture]');
  if (ouv) {
    var fond = $('[data-parallaxe]', ouv), scene = $('[data-ouv-scene]', ouv), livre = scene && $('.livre', scene), couv = scene && $('.livre__couv', scene);
    var titre = $('[data-ouv-titre]', ouv), ligne = $('.ouv__ecrit', ouv);
    var suite = $$('.ouv__chapeau, .ouv__actions, .lec-bloc, .ouv__preuves', ouv);
    var plLigne = ligne ? ecrire(ligne, ligne.dataset.vara, { taille: telephone() ? 28 : 36, couleur: '#a23d22', trait: 1.6 }) : null;
    document.documentElement.classList.add('ln-go'); /* le scénario prend la main dans la même image : aucun clignement */
    var tl = g.timeline({ defaults: { ease: 'power3.out' } });
    /* le panorama se dévoile en lumière : il part d'un blanc doré et se colore */
    /* le paysage, le titre et le bouton sont là tout de suite (14/10/2026) : seule une légère respiration du paysage, sans flou */
    tl.fromTo(fond, { scale: 1.04 }, { scale: 1.02, duration: 2.4, ease: 'power2.out' }, 0);
    tl.add(function () { if (plLigne) plLigne.dessiner(); }, .95);
    if (livre) {
      if (!telephone()) {
        /* ordinateur : le livre se pose dans l'herbe, fermé, puis s'ouvre (courbe physique : élan, dépassement, repos) */
        g.set(couv, { rotationY: 0 }); scene.classList.add('is-ferme'); scene.classList.remove('is-ecrit');
        tl.fromTo(livre, { y: -70, rotationX: 38, opacity: 0 }, { y: 0, rotationX: 16, opacity: 1, duration: 1.2, ease: 'back.out(1.25)' }, .8);
        tl.to(couv, { rotationY: -182, duration: 1.45, ease: 'power3.inOut', onStart: function () { scene.classList.remove('is-ferme'); } }, 2.15);
        tl.to(couv, { rotationY: -172, duration: .55, ease: 'power2.out' }, 3.6);
        tl.add(function () { scene.classList.add('is-ecrit'); }, 3.0);
      } else {
        /* téléphone : le livre fermé se pose dans les blés (la grand-mère et l'enfant restent visibles) */
        tl.fromTo(livre, { y: -40, opacity: 0, rotationX: 70 }, { y: 0, opacity: 1, rotationX: 52, duration: 1.1, ease: 'back.out(1.4)' }, 1.0);
      }
    }
    /* parallaxe douce du panorama */
    if (fond) g.to(fond, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: ouv, start: 'top top', end: 'bottom top', scrub: true } });
  }
  /* la première page (téléphone) : le livre s'ouvre quand on y arrive, puis Mamie écrit */
  var o2 = $('[data-ouv2-scene]');
  if (o2) {
    var c2 = $('.livre__couv', o2), l2 = $('.livre', o2);
    if (telephone()) {
      g.set(c2, { rotationY: 0 });
      ST.create({ trigger: o2, start: 'top 72%', once: true, onEnter: function () {
        var t2 = g.timeline();
        t2.from(l2, { y: 30, rotationX: 30, duration: .8, ease: 'power3.out' })
          .to(c2, { rotationY: -182, duration: 1.3, ease: 'power3.inOut' }, .2)
          .to(c2, { rotationY: -172, duration: .5, ease: 'power2.out' })
          .add(function () { o2.classList.add('is-ecrit'); }, .9);
      } });
    }
  }

  /* ---------- le chemin : transitions à ressort, phrase réécrite à la plume ---------- */
  $$('[data-chemin]').forEach(function (ch) {
    var phrase = $('[data-chemin-phrase]', ch), plPhrase = null;
    ch.addEventListener('ln:arret', function (ev) {
      var a = ev.detail.arret, pt = $('.arret__pt', a);
      g.fromTo(pt, { scale: .7 }, { scale: 1.14, duration: .9, ease: 'elastic.out(1, .45)' });
      /* la page elle-même tourne dans ln.js (tourner) : plus de bascule ici (15/10/2026) */
      /* la phrase s'écrit à la plume, dans l'encre de l'auteur */
      setTimeout(function () {
        var sp = $('span', phrase); if (!sp) return;
        $$('.plume', phrase).forEach(function (x) { x.remove(); });
        plPhrase = ecrire(phrase, a.dataset.phrase, { taille: telephone() ? 26 : 32, couleur: getComputedStyle(phrase).color, trait: 1.5, duree: 1600 });
        if (plPhrase) plPhrase.dessiner();
      }, 230);
    });
    ST.create({ trigger: ch, start: 'top 70%', once: true, onEnter: function () {
      g.from($$('.arret', ch), { y: 24, opacity: 0, duration: .7, ease: 'back.out(1.6)', stagger: .07, clearProps: 'transform,opacity' });
      var a0 = $('.arret[aria-pressed="true"]', ch); if (a0) ch.dispatchEvent(new CustomEvent('ln:arret', { detail: { i: 0, arret: a0, phrase: phrase } }));
    } });
  });

  /* Vignettes : affichées telles quelles. L'aquarelle animée (filtres SVG au défilement) a été retirée le 14/10/2026 : trop coûteuse, elle faisait saccader. */

  /* ---------- le tourne-page : courbure, ombre qui glisse, reflet ---------- */
  LNA.tourner = function (feuille, faceSrc, dosSrc, fini) {
    var face = $('.face', feuille), dos = $('.dos', feuille);
    $('img', face).src = faceSrc; $('img', dos).src = dosSrc || '';
    if (!$('.ombre-f', face)) { face.insertAdjacentHTML('beforeend', '<i class="ombre-f"></i><i class="reflet-f"></i>'); dos.insertAdjacentHTML('beforeend', '<i class="ombre-f"></i>'); }
    var sous = feuille.parentNode.querySelector('.feuil__ombre-sous') || (function () { var o = document.createElement('i'); o.className = 'feuil__ombre-sous'; feuille.parentNode.appendChild(o); return o; })();
    feuille.style.transition = 'none'; feuille.hidden = false;
    var tl = g.timeline({ onComplete: function () { feuille.hidden = true; g.set([feuille, sous], { clearProps: 'all' }); feuille.style.transition = ''; fini(); } });
    tl.set(feuille, { rotationY: 0, skewY: 0 })
      .to(feuille, { rotationY: -180, duration: 1.15, ease: 'power2.inOut' }, 0)
      .to(feuille, { skewY: -2.2, duration: .55, ease: 'sine.out' }, 0)          /* la feuille se courbe en se soulevant */
      .to(feuille, { skewY: 0, duration: .6, ease: 'sine.in' }, .55)
      .fromTo($('.ombre-f', face), { opacity: 0 }, { opacity: .5, duration: .6, ease: 'power1.in' }, 0)
      .fromTo($('.ombre-f', dos), { opacity: .45 }, { opacity: 0, duration: .55, ease: 'power1.out' }, .6)
      .fromTo($('.reflet-f', face), { xPercent: -120, opacity: 0 }, { xPercent: 140, opacity: .9, duration: .7, ease: 'power1.inOut' }, .05)
      .fromTo(sous, { opacity: 0, scaleX: 1 }, { opacity: .55, scaleX: .1, duration: 1.15, ease: 'power2.inOut' }, 0);
  };

  /* ---------- le bouton d'achat magnétique (ordinateur) ---------- */
  if (window.matchMedia('(hover: hover)').matches) {
    $$('[data-aimant], .offre__actions .l-btn, .fin__essai .l-btn').forEach(function (b) {
      var x = g.quickTo(b, 'x', { duration: .45, ease: 'power3.out' }), y = g.quickTo(b, 'y', { duration: .45, ease: 'power3.out' });
      var zone = b.parentNode;
      zone.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect(), dx = ev.clientX - (r.left + r.width / 2), dy = ev.clientY - (r.top + r.height / 2);
        var dist = Math.hypot(dx, dy); if (dist > 140) { x(0); y(0); return; }
        x(dx * .22); y(dy * .3);
      });
      zone.addEventListener('pointerleave', function () { x(0); y(0); });
    });
  }

  /* Les blocs ne « surgissent » plus au défilement (retiré le 14/10/2026) : le contenu est là, tout de suite. */

  /* ---------- le dernier mot : le prénom s'écrit à la plume ---------- */
  var essai = $('[data-prenom-essai]'), plPre = $('[data-plume-prenom]'), minuterie;
  if (essai && plPre) {
    var dessinePrenom = function () {
      $$('.plume', plPre).forEach(function (x) { x.remove(); });
      var p = (essai.value || 'Léo').trim() || 'Léo';
      plPre.firstElementChild.textContent = 'Pour ' + p;
      var pl = ecrire(plPre, 'Pour ' + p, { police: 'parisienne', taille: telephone() ? 34 : 46, couleur: '#a23d22', trait: 1.6, duree: 1500 });
      if (pl) pl.dessiner();
    };
    ST.create({ trigger: plPre, start: 'top 85%', once: true, onEnter: dessinePrenom });
    essai.addEventListener('input', function () { clearTimeout(minuterie); minuterie = setTimeout(dessinePrenom, 650); });
  }

  window.addEventListener('load', function () { ST.refresh(); });
})();
